module.exports = __webpack_public_path__ + "img/PXL_20230525_145309332.221d87ce.jpg";